import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
import {
    makeSelectQueryStringBooleanValue,
    makeSelectQueryStringNumberValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import GroupName from 'components/GroupName';
import RoleGate from 'components/RoleGate';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';

// Components
// @ts-ignore
import GroupDeleteForm from './components/GroupDeleteForm';

interface ConnectedProps {
    isOpen: boolean;
    id?: number;
}

interface DispatchProps {
    updateQueryString: Function;
}

type Props = ConnectedProps & DispatchProps;

export class GroupDeleteModal extends React.PureComponent<Props> {
    handleClose = (): void => {
        this.props.updateQueryString({
            groupDeleteModal: undefined,
            selectedGroup: undefined
        });
    };

    render(): React.ReactElement | null {
        const { isOpen, id } = this.props;

        if (!id) {
            return null;
        }

        return (
            <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                <Modal
                    size="tiny"
                    open={isOpen}
                    centered={false}
                    onClose={this.handleClose}
                    closeIcon
                >
                    <ErrorBoundary
                        namespace="GroupDeleteModal"
                        FallbackComponent={<ErrorBoundaryAlert />}
                    >
                        <Modal.Header>
                            {'Delete '}
                            <GroupName groupId={id} />
                        </Modal.Header>
                        <Modal.Content>
                            <p>Are you sure you want to delete this group?</p>
                            <GroupDeleteForm
                                groupId={id}
                                onClose={this.handleClose}
                            />
                        </Modal.Content>
                    </ErrorBoundary>
                </Modal>
            </RoleGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    isOpen: makeSelectQueryStringBooleanValue('groupDeleteModal'),
    id: makeSelectQueryStringNumberValue('selectedGroup')
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(GroupDeleteModal);
